type AddErrorBannerProps = {
  message: string;
};

export default function AddErrorBanner({ message }: AddErrorBannerProps) {
  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-3">
      <div className="flex gap-x-2">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          className="text-red-600 shrink-0 mt-0.5"
          aria-hidden="true"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M15 9l-6 6M9 9l6 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <p className="text-sm text-red-800" translate="no">
          {message}
        </p>
      </div>
    </div>
  );
}
